import { useQuery } from '@tanstack/react-query'
import { fetchCarePlans } from '../services/care_plan';

const GetCarePlan = (startDate = null, endDate = null, carePlanTypes = null, meetingTypes = null, authorIds = null, pageNumber = 1, pageSize = 10) => {
 const carePlan = useQuery({
    queryKey:['care_plan', startDate, endDate, carePlanTypes, meetingTypes, authorIds, pageNumber, pageSize],
    queryFn: () => fetchCarePlans(startDate, endDate, carePlanTypes, meetingTypes, authorIds, pageNumber, pageSize)
 })
 return carePlan;
}

export default GetCarePlan